<template>
  <div>
    <app-contentpageheader>
      <b-img
        slot="entrySectionImage"
        fluid
        alt="Responsive image"
        :src="backgroundImg"
      />
      <h3 slot="entrySectionText">Pielęgnacja</h3>
    </app-contentpageheader>
    <app-maintenance />
    <app-footer />
  </div>
</template>
<script>
import ContentPageHeader from "../../components/common/ContentPageHeader.vue";
import Maintenance from "../../components/offer/Maintenance.vue";
import Footer from "../../components/common/Footer.vue";
export default {
  data() {
    return {
      backgroundImg: require("../../assets/offer/pielegnacja_podlogi.jpg")
    };
  },
  components: {
    "app-maintenance": Maintenance,
    "app-footer": Footer,
    "app-contentpageheader": ContentPageHeader
  }
};
</script>
<style scoped>

</style>
